import { render, staticRenderFns } from "./playpenLogoW.vue?vue&type=template&id=43a75ad2&scoped=true&"
import script from "./playpenLogoW.vue?vue&type=script&lang=js&"
export * from "./playpenLogoW.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a75ad2",
  null
  
)

export default component.exports